export default function initMobilFormTabs() {
	const subscribeForm = document.querySelector('.js-subscribe-form');

	if (!subscribeForm) {
		return;
	}

	const dropOpener = subscribeForm.querySelector('.js-drop-opener');
	const drop = subscribeForm.querySelector('.js-subscribe-form-drop');

	let text;

	function changeOpenerText(el) {
		text = el.textContent;
		dropOpener.textContent = text;
	}

	const tabsNav = [...subscribeForm.querySelectorAll('.js-form-tabs-nav button')];

	tabsNav.forEach((button) => {
		if (button.classList.contains('active')) {
			changeOpenerText(button);
		}

		button.addEventListener('shown.bs.tab', () => {
			changeOpenerText(button);
			jQuery(drop).collapse('hide');
		});
	});
}
